import { render } from "./ShowFooter.vue?vue&type=template&id=2bb3cc84"
import script from "./ShowFooter.vue?vue&type=script&lang=js"
export * from "./ShowFooter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__